/**
 * 特集詳細の初期化
 */
export function initFeaturesDetail($) {
  if ($('body.single-features').length === 0) return;

  // スライド
  $('.s-features-detail__contents .c-slide').each(function() {

    const $slider   = $(this);
    const itemCount = $slider.find('.c-slide__item').length;

    // アイテムが0個の場合はスライドを初期化しない
    if (itemCount === 0) return;

    const showDots = itemCount > 1;

    // slickが利用可能か確認
    if (typeof $slider.slick !== 'function') {
      console.warn('Slick is not loaded');
      return;
    }

    // slick 初期化
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: itemCount > 1,
      arrows: true,
      dots: showDots,
    });
    
    // fancyboxの重複を防ぐため、クローン要素からdata-fancybox属性を削除
    $slider.find('.slick-cloned a.fancybox').removeAttr('data-fancybox');

  });


  let images = document.querySelectorAll('.s-features-detail__contents--snowlive-image img');
  let iframes = document.querySelectorAll('.s-features-detail__contents--snowlive-iframe iframe');

  let ts, i;
  images.forEach(function(element) {
    element.setAttribute('data', element.getAttribute('src'));
  });
  iframes.forEach(function(element) {
    element.setAttribute('data', element.getAttribute('src'));
  });

  //  iframes[i].setAttribute('data', iframes[i].getAttribute('src'));


  setInterval(function() {
    ts = '?ts=' + new Date().getTime();

    images.forEach(function(element) {
      element.setAttribute('src', element.getAttribute('data') + ts);
    });
    iframes.forEach(function(element) {
      element.setAttribute('src', element.getAttribute('data') + ts);
    });


  //  for (i=0; i<images.length; i++) {
  //    images[i].setAttribute('src', images[i].getAttribute('data') + ts);
  //    iframes[i].setAttribute('src', iframes[i].getAttribute('data') + ts);
  //  }

  }, 300000);
  // }, 3000);

  /*
  let col = document.getElementById('columns');
  let item = document.querySelector('.ski-areas');
  col.addEventListener('change', function() {
    console.log(item.classList);
    item.classList.toggle('column2');
  });

  let ski_area = document.querySelectorAll('.ski-area');
  let click_area = document.createElement("div");
  click_area.classList.add('click_area');
  let body = document.querySelector('body');
  ski_area.forEach(function(area) {
    let work = click_area.cloneNode(true);
    work.addEventListener('click', function(element) {
      let id = element.target.parentNode.getAttribute('id');
      location.href = 'https://taisetsu-activity.jp/taisetsu-snow-live/' + id;

    });
    area.append(work);
  });
  */
}
